import { useEffect, useState } from 'react'
import { Route, Routes, useNavigate, useParams } from 'react-router-dom'
import { Header } from './components/Header'
import { TabBar } from './components/TabBar'
import { Loading } from './components/bits'
import { useI18n } from './i18n'
import { api, ApiError } from './lib/api'
import { useSession } from './store/session'
import { Home } from './screens/Home'
import { CheckIn } from './screens/CheckIn'
import { Draw } from './screens/Draw'
import { Analysis } from './screens/Analysis'
import { Exercise } from './screens/Exercise'
import { Result } from './screens/Result'
import { FreeResult } from './screens/FreeResult'
import { Journal } from './screens/Journal'
import { Dialogs } from './screens/Dialogs'
import { Room } from './screens/Room'
import { ReplyQuestion } from './screens/ReplyQuestion'

function Shell() {
  const { t } = useI18n()
  const screen = useSession((s) => s.screen)
  const loadMsg = useSession((s) => s.loadMsg)

  return (
    <>
      <div id="app">
        <Header />
        {screen === 'home' && <Home />}
        {screen === 'pre' && <CheckIn />}
        {screen === 'draw' && <Draw />}
        {screen === 'load' && <Loading msg={loadMsg || t.load.default} />}
        {screen === 'analysis' && <Analysis />}
        {screen === 'exercise' && <Exercise />}
        {screen === 'result' && <Result />}
        {screen === 'fresult' && <FreeResult />}
        {screen === 'journal' && <Journal />}
        {screen === 'dialogs' && <Dialogs />}
        {screen === 'room' && <Room />}
        {screen === 'replyq' && <ReplyQuestion />}
      </div>
      <TabBar />
    </>
  )
}

/** Ссылка-диалог из мессенджера: открывается без установки и сразу ведёт в комнату. */
function DeepLink() {
  const { id, mid } = useParams<{ id: string; mid?: string }>()
  const nav = useNavigate()
  const s = useSession()
  const { t } = useI18n()
  const [state, setState] = useState<'load' | 'locked' | 'missing'>('load')

  useEffect(() => {
    if (!id) return
    api
      .getDialog(id)
      .then((d) => {
        s.set({ activeDialog: d, focusMsgId: mid ? Number(mid) || null : null })
        s.go('room')
        nav('/', { replace: true })
      })
      .catch((e) => setState(e instanceof ApiError && e.status === 403 ? 'locked' : 'missing'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, mid])

  if (state !== 'load') {
    return (
      <div id="app">
        <Header />
        <section className="screen">
          <p className="center-note">{state === 'locked' ? t.dialogs.lockedPage : t.dialogs.notFound}</p>
          <div className="btn-row">
            <button className="btn btn-ink" onClick={() => nav('/', { replace: true })}>{t.dialogs.goHome}</button>
          </div>
        </section>
      </div>
    )
  }
  return (
    <div id="app">
      <Header />
      <Loading msg={t.load.default} />
    </div>
  )
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Shell />} />
      <Route path="/d/:id" element={<DeepLink />} />
      <Route path="/d/:id/m/:mid" element={<DeepLink />} />
      <Route path="*" element={<Shell />} />
    </Routes>
  )
}
